import { useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { ChecklistSettingsDashboardQueryKeys } from "modules/ChecklistSettingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";
import type { ReportTemplate } from "models";

const formatReportTemplatesOptions = (templates: ReportTemplate[]): DropdownItemProps[] => templates.map(({ id, name }) => ({ key: id, value: id, text: name }));

export const useReportTemplatesQuery = () => {
  const { selectedDealer } = useSelectedDealer();

  return useTypedQuery({
    queryKey: ChecklistSettingsDashboardQueryKeys.reportTemplates,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_id: selectedDealer?.id }, baseUrl)).data.report_templates,
    enabled: Boolean(selectedDealer?.id),
    refetchOnDependencies: [selectedDealer?.id],
    select: formatReportTemplatesOptions
  });
};
